import styled, { css } from 'styled-components';

export const PageFooterWrapper = styled.div((props) => {
  return css`
    @media (max-width: 375px) {
      [class*='ListItemstyle__ListItem-sc'] {
        a {
          min-width: 160px;
        }
      }
      @media (max-width: 320px) {
        [class*='ListItemstyle__ListItem-sc'] {
          a {
            min-width: 140px;
          }
        }
      }
    }

    @media (max-width: ${props.theme.breakpoints.md}px) {
      [class*='ListItemstyle__ListItem-sc'] {
        &:nth-child(odd) {
          text-align: right;
        }
        &:nth-child(even) {
          text-align: left;
        }
      }
    }
`});